<div class="chart-container">
  <canvas #stockPriceChart id="stockPriceChart"></canvas>
  <canvas #chartNavigator id="chartNavigator"></canvas>
</div>
